import { render, staticRenderFns } from "./cellTemplate.vue?vue&type=template&id=51f44ede&"
import script from "./cellTemplate.vue.ts?vue&type=script&lang=js&"
export * from "./cellTemplate.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports